import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE, PRICE_ORIGINAL } from '../data/content';
const recap = ['6 冊教材', '5 份附送', '240 頁', '小一至中三', '可列印'];
const reassurances = ['即時下載', '工作紙可直接列印', '7 天退款保證'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-118" data-mp="15dly59p3rgyf">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-119" data-mp="1jcvc02pu5yz8" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-120" data-mp="1ed0lw1dvxdf8">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-121" data-mp="1t2yagifq854y">
          你的音樂課，<em className="text-red-700" data-id="element-122" data-mp="1o3bptnxkjmm4">今天就可以準備好。</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-123" data-mp="1o67ml8xok58z">
          不用再找歌曲和活動、自己做每一份工作紙、把週末都花在備課上——你有一套整理好的全年音樂教材。把時間留給真正重要的事：
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-124" data-mp="1x64hhsany0ch">
          你的學生。你的課堂。你在學校以外的生活。
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-125" data-mp="s4pd9s6rqkch">
          {recap.map(item => <li key={item} data-id="element-126" data-mp="x3iofdyl1z9h">{item}</li>)}
        </ul>

        <p className="mt-8 text-base text-slate-900/60" data-id="element-127" data-mp="x64ybk8y4quv">原價 <s data-id="element-128" data-mp="123woo9ty04wy">{PRICE_ORIGINAL}</s></p>
        <p className="mt-2 whitespace-nowrap font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-129" data-mp="1246hs6aaas6v">{PRICE}</p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-130" data-mp="1b3a0h95jh5ku">一次付款——無需訂閱。</p>

        <div className="mt-8 flex justify-center" data-id="element-131" data-mp="1b1grhn7ge99o">
          <CtaButton className="w-full sm:w-auto" data-id="element-132" data-mp="1fu06molshcgl" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-133" data-mp="1ktd2tzyjvvvu">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-134" data-mp="1pt8vx45pm2wm">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-135" data-mp="1pqmrhde483im" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}